import React from 'react';
import Container from 'components/Container';
import { IconName } from 'components/Icon';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';
import CoachingHeading from 'coaching/components/CoachingHeading';

import 'coaching/components/styles/CoachingHelpSectionHeader.scss';

export default function CoachingHelpSectionHeader({
  icon,
  headerText,
  detailText,
}: {
  icon: IconName;
  headerText: string;
  detailText?: string;
}) {
  return (
    <Container size="small" align="left">
      <CoachingHeading level="2" textSize="xlarge">
        <TextWithIcon
          className="CoachingHelpSectionHeader-icon"
          icon={icon}
          iconSize="large"
          center>
          {headerText}
        </TextWithIcon>
      </CoachingHeading>
      {detailText && (
        <Row>
          <Text size="medium" color="graphite">
            {detailText}
          </Text>
        </Row>
      )}
    </Container>
  );
}
